// Slice names for pie chart sections
export const SLICE_NAMES = [
  'Color Choices',
  'Material',
  'Abrasion Resistance',
  'Price',
  'Expansion',
  'Cutting Tool',
  'Flexibility',
  'Max Continuous Temp'
]

// Coordinate mappings for each slice size and position
// Format: { lineTo, bControl, end, icon, iconX, iconY, useMaterialIcon, useToolIcon }
export const SLICE_COORDINATES = {
  // Color choices
  'A1': { lineTo: [100, 66], bControl: [115, 68], end: [124, 77] },
  'A2': { lineTo: [100, 33], bControl: [130, 35], end: [147, 54] },
  'A3': { lineTo: [100, 0], bControl: [140, 0], end: [170, 30], icon: 'color', iconX: 115, iconY: 25 },
  
  // Material - icon will be set dynamically
  'B1': { lineTo: [123, 76], bControl: [133, 85], end: [133, 100] },
  'B2': { lineTo: [147, 54], bControl: [165, 70], end: [166, 100] },
  'B3': { lineTo: [170, 30], bControl: [200, 60], end: [200, 100], iconX: 155, iconY: 60, useMaterialIcon: true },
  
  // Abrasion
  'C1': { lineTo: [133, 100], bControl: [133, 115], end: [123, 123] },
  'C2': { lineTo: [166, 100], bControl: [165, 130], end: [146, 146] },
  'C3': { lineTo: [200, 100], bControl: [200, 140], end: [170, 170], icon: 'abrasion', iconX: 155, iconY: 113 },
  
  // Price
  'D1': { lineTo: [123, 123], bControl: [115, 133], end: [100, 133] },
  'D2': { lineTo: [146, 146], bControl: [130, 165], end: [100, 166] },
  'D3': { lineTo: [170, 170], bControl: [140, 200], end: [100, 200], icon: 'cost', iconX: 115, iconY: 155 },
  
  // Expansion
  'E1': { lineTo: [100, 133], bControl: [85, 133], end: [76, 123] },
  'E2': { lineTo: [100, 166], bControl: [70, 165], end: [53, 146] },
  'E3': { lineTo: [100, 200], bControl: [60, 200], end: [29, 169], icon: 'expansion', iconX: 60, iconY: 155 },
  
  // Cutting Tool - icon will be set dynamically
  'F1': { lineTo: [76, 123], bControl: [68, 115], end: [66, 100] },
  'F2': { lineTo: [53, 146], bControl: [35, 130], end: [33, 100] },
  'F3': { lineTo: [30, 170], bControl: [0, 140], end: [0, 100], iconX: 27, iconY: 113, useToolIcon: true },
  
  // Flexibility
  'G1': { lineTo: [66, 100], bControl: [68, 85], end: [76, 76] },
  'G2': { lineTo: [33, 100], bControl: [35, 70], end: [53, 53] },
  'G3': { lineTo: [0, 100], bControl: [0, 60], end: [30, 30], icon: 'flex', iconX: 15, iconY: 55 },
  
  // Temperature
  'H1': { lineTo: [76, 76], bControl: [85, 68], end: [100, 66] },
  'H2': { lineTo: [53, 53], bControl: [70, 35], end: [100, 33] },
  'H3': { lineTo: [30, 30], bControl: [60, 0], end: [100, 0], icon: 'temp', iconX: 60, iconY: 25 }
}

// Get slice coordinates by key
export function getSliceCoordinates(sliceKey) {
  return SLICE_COORDINATES[sliceKey]
}

// Calculate slice sizes based on product data
export function calculateSliceSizes(data) {
  const type = data.wrap === '1' ? 'wrap' : 'sleeve'
  const material = 3

  // Cost
  let sliceCost
  if (data.cost_distributor >= 5) {
    sliceCost = 3
  } else if (data.cost_distributor > 1.5) {
    sliceCost = 2
  } else {
    sliceCost = 1
  }

  // Color
  let sliceSizeColor
  if (data.pie_color >= 15) {
    sliceSizeColor = 3
  } else if (data.pie_color >= 4) {
    sliceSizeColor = 2
  } else if (data.pie_color >= 2) {
    sliceSizeColor = 1
  } else {
    sliceSizeColor = 0
  }

  // Temperature
  let sliceSizeTemp
  if (data.temp_continuous > 1000) {
    sliceSizeTemp = 3
  } else if (data.temp_continuous >= 300) {
    sliceSizeTemp = 2
  } else {
    sliceSizeTemp = 1
  }

  // Expansion
  let sliceSizeExpansion
  if (data.pie_expansion >= 150) {
    sliceSizeExpansion = 3
  } else if (data.pie_expansion >= 50) {
    sliceSizeExpansion = 2
  } else if (data.pie_expansion > 0) {
    sliceSizeExpansion = 1
  } else {
    sliceSizeExpansion = 0
  }

  return {
    letterVals: [
      sliceSizeColor,
      material,
      data.pie_abrasion,
      sliceCost,
      sliceSizeExpansion,
      data.pie_tool,
      data.pie_flexibility,
      sliceSizeTemp
    ],
    type
  }
}
